import fedHolidays from '@18f/us-federal-holidays';
import {fromZonedTime} from 'date-fns-tz';

document.addEventListener('DOMContentLoaded', function () {

    // Function to handle accordion behavior
    function handleAccordionChange(event)
    {
        const radio = event.target;
        if (radio.checked) {
            const headerTextElement = radio.closest('.accordion-item').querySelector('.accordion-button .js-chosen');
            const headerText = radio.getAttribute('data-name');
            headerTextElement.innerText = headerText;

            // Update the src of the image with id "bpic"
            if (radio.name === 'pic') {
                document.getElementById('bpic').src = radio.dataset.imagesourceStandard;
                document.getElementById('selected-background-sample').innerText = headerText;
            }
            if (radio.name === 'products[0]') {
                document.getElementById('framepic').src = radio.dataset.overlay;
            }

            // Update the total price
            updateTotalPrice();
        }
        if (!document.querySelector('input[name="products[0]"]:checked')) {
            const sizeSelected = document.querySelector('input[name="size"]:checked');

            let size = ''
            if (sizeSelected && (sizeSelected.value !== '16x20' && sizeSelected.value !== '16x20pyo' && sizeSelected.value !== '16x20pdp' && sizeSelected.value !== '16x20pd')) {
                size = sizeSelected.value.replace('pyo', '').replace('pdp', '').replace('pd', '');
            }
            document.getElementById('framepic').src = '/images/3pframes/overlays/blank'+size+'.webp';
        }

    }

    // Function to update the total price
    function updateTotalPrice()
    {
        let totalPrice = 0;
        const templateElem = document.getElementById('orderOptionTemplate');
        const orderOptionsList = document.getElementById('orderOptionsList');
        orderOptionsList.innerHTML = '';

        // Calculate the additional options price
        document.querySelectorAll('input[name^="products"]:checked,input[name="companylogo"]:checked,input[name="style"]:checked,input[name="size"]:checked').forEach(checkbox => {
            const price = parseFloat(checkbox.dataset.price);
            if ( Number.isNaN(price) ) {
                return;
            }
            totalPrice += price || 0;
            const template = templateElem.cloneNode(true);
            template.querySelector('h6').innerText = checkbox.getAttribute('data-name');
            template.querySelector('span').innerText = '$'+price.toFixed(2);
            orderOptionsList.appendChild(template);
        });

        // Update the total price display
        const totalTemplate = document.getElementById('orderTotalTemplate').cloneNode(true);
        totalTemplate.querySelector('li.list-group-item strong').innerText = `$${totalPrice.toFixed(2)}`;
        orderOptionsList.appendChild(totalTemplate);
    }

    document.querySelectorAll('input[name^="products"]').forEach(checkbox => {
        checkbox.addEventListener('change', updateTotalPrice);
    });

    // Add event listeners to all radio buttons with name 'delivery'
    const backgroundRadios = document.querySelectorAll('input[name="pic"]');
    backgroundRadios.forEach(radio => {
        radio.addEventListener('change', handleAccordionChange);
    });

    // Add event listeners to all radio buttons with name 'delivery'
    const deliveryRadios = document.querySelectorAll('input[name="delivery"]');
    deliveryRadios.forEach(radio => {
        radio.addEventListener('change', handleAccordionChange);
    });


    const itemVisibilityHide = function (item) {
        item.classList.add('d-none');
        item.querySelectorAll('input[required]').forEach(input => {
            input.setAttribute('data-required', 'required');
            input.removeAttribute('required');
            if ( input.checked ) {
                input.dataset.checked = true;
            } else {
                delete input.dataset.checked;
            }
            input.checked = false;
            const changeEvent = new Event('change');
            input.dispatchEvent(changeEvent);
        });
    }
    const itemVisibilityShow = function (item) {
        item.classList.remove('d-none');
        item.querySelectorAll('input[data-required]').forEach(input => {
            input.required = true;
        });
        item.querySelectorAll('input[data-checked]').forEach(input => {
            input.checked = true;
            const changeEvent = new Event('change');
            input.dispatchEvent(changeEvent);
        });
    }

    const updateSizeOptions = () => {
        const selected = document.querySelector('input[name="size"]:checked');
        if ( ! selected ) {
            return;
        }

        document.querySelectorAll('#choose-frame-item input[data-value-24x36]').forEach((input) => {
            if (!input.dataset['value-16x20']) {
                input.dataset['value-16x20'] = input.value;
            }
            input.value = input.dataset['value-'+selected.value];
        });

    if ( '16x20' === selected.value ) {
        document.querySelectorAll('[data-content-24x36]').forEach(elem => {
            elem.innerText = elem.dataset['content-16x20'];
            });
        document.querySelectorAll('[data-price-24x36]').forEach(elem => {
            elem.dataset.price = elem.dataset['price-16x20'];
            });
    } else if ( '11x14' === selected.value) {
        document.querySelectorAll('[data-content-24x36]').forEach(elem => {
            elem.innerText = elem.dataset['content-11x14'];
            });
        document.querySelectorAll('[data-price-24x36]').forEach(elem => {
            elem.dataset.price = elem.dataset['price-11x14'];
            });
    } else if ( '8x10' === selected.value) {
        document.querySelectorAll('[data-content-24x36]').forEach(elem => {
            elem.innerText = elem.dataset['content-11x14'];
            });
        document.querySelectorAll('[data-price-24x36]').forEach(elem => {
            elem.dataset.price = elem.dataset['price-11x14'];
            });
    } else if ( '24x36' === selected.value) {
        document.querySelectorAll('[data-content-24x36]').forEach(elem => {
            elem.innerText = elem.dataset['content-24x36'];
            });
        document.querySelectorAll('[data-price-24x36]').forEach(elem => {
            elem.dataset.price = elem.dataset['price-24x36'];
            });
    } else {
        document.querySelectorAll('[data-content-24x36]').forEach(elem => {
            elem.innerText = elem.dataset['content-16x20'];
            });
        document.querySelectorAll('[data-price-24x36]').forEach(elem => {
            elem.dataset.price = elem.dataset['price-16x20'];
            });
        document.querySelectorAll('.choose-frame-item').forEach(itemVisibilityHide);
    }

    if ( '24x36' === selected.value || '24x36pyo' === selected.value ) {
        document.querySelectorAll('#choose-background img[data-src-24x36]').forEach((img) => {
            if ( img.dataset['src-24x36']) {
                if ( ! img.dataset['src-16x20']) {
                    img.dataset['src-16x20'] = img.src;
                }
                img.src = img.dataset['src-24x36'];
            }
        });
        document.querySelectorAll('input[data-overlay-24x36]').forEach((img) => {
            if ( img.dataset['overlay-24x36']) {
                if ( ! img.dataset['overlay-16x20']) {
                    img.dataset['overlay-16x20'] = img.dataset.overlay;
                }
                img.dataset.overlay = img.dataset['overlay-24x36'];
                if (img.checked) {
                    document.getElementById('framepic').src = img.dataset.overlay;
                }
            }
        });
        document.querySelectorAll('[data-style-24x36]').forEach((elem) => {
            if ( elem.dataset['style-24x36']) {
                if ( ! elem.dataset['style-16x20']) {
                    elem.dataset['style-16x20'] = elem.style.cssText;
                }
                elem.style = elem.dataset['style-24x36'];
            }
            if ( elem.dataset['styleZoom-24x36']) {
                if ( ! elem.dataset['styleZoom-16x20']) {
                    elem.dataset['styleZoom-16x20'] = elem.dataset.styleZoom;
                }
                elem.dataset.styleZoom = elem.dataset['styleZoom-24x36'];
            }
            });

        document.querySelectorAll('#choose-background input[data-value-24x36]').forEach((input) => {
            if ( ! input.dataset['value-16x20']) {
                input.dataset['value-16x20'] = input.value;
            }
            input.value = input.dataset['value-24x36'];
            if ( ! input.dataset['imagesource-16x20']) {
                input.dataset['imagesource-16x20'] = input.dataset.imagesourceStandard;
            }
            if (input.dataset['imagesource-24x36']) {
                const portraitOnly = document.querySelector('input[name="portraitonly"]:checked')
                if ( portraitOnly && 'yes' === portraitOnly.value) {
                    input.dataset.imagesourceStandard = input.dataset['imagesource-24x36'].replace('.webp', ' no text.webp');
                } else {
                    input.dataset.imagesourceStandard = input.dataset['imagesource-24x36'];
                }
            }
            if ( input.checked) {
                document.getElementById('bpic').src = input.dataset.imagesourceStandard;
            }
            });
        document.querySelectorAll('.show-24x36').forEach(elem => {
            itemVisibilityShow(elem);
            });
        document.querySelectorAll('.hide-24x36').forEach(elem => {
            itemVisibilityHide(elem);
            });
    } else {
        document.querySelectorAll('.hide-24x36').forEach(elem => {
            itemVisibilityShow(elem);
            });
        document.querySelectorAll('.show-24x36').forEach(elem => {
            itemVisibilityHide(elem);
            });
        document.querySelectorAll('#choose-background [data-src-24x36]').forEach((img) => {
            if ( img.dataset['src-16x20']) {
                img.src = img.dataset['src-16x20'];
            }
        });

        document.querySelectorAll('input[data-overlay-24x36]').forEach((img) => {
            if ( img.dataset['overlay-16x20']) {
                img.dataset.overlay = img.dataset['overlay-16x20'];
                if (img.checked) {
                    document.getElementById('framepic').src = img.dataset.overlay;
                }
            }
        });

        if ( '11x14' === selected.value) {
            document.querySelectorAll('[data-style-11x14]').forEach((elem) => {
                if ( elem.dataset['style-11x14']) {
                    if ( ! elem.dataset['style-16x20']) {
                        elem.dataset['style-16x20'] = elem.style.cssText;
                    }
                    elem.style = elem.dataset['style-11x14'];
                }
                if ( elem.dataset['styleZoom-11x14']) {
                    if ( ! elem.dataset['styleZoom-16x20']) {
                        elem.dataset['styleZoom-16x20'] = elem.dataset.styleZoom;
                    }
                    elem.dataset.styleZoom = elem.dataset['styleZoom-11x14'];
                }
                });
        } else {
            document.querySelectorAll('[data-style-24x36]').forEach((img) => {
                if (img.dataset['styleZoom-16x20']) {
                    img.dataset.styleZoom = img.dataset['styleZoom-16x20'];
                }
                });
        }
        document.querySelectorAll('#choose-background input[data-value-24x36]').forEach((input) => {
            if ( input.dataset['value-16x20']) {
                input.value = input.dataset['value-16x20'];
            }
            if ( input.dataset['imagesource-16x20']) {
                input.dataset.imagesourceStandard = input.dataset['imagesource-16x20'];
            }
            if ( input.checked) {
                document.getElementById('bpic').src = input.dataset.imagesourceStandard;
            }
            });
    }
    }

    updateSizeOptions();

    const updatePortraitOnly = function (event) {
        if (event.target.checked && 'yes' === event.target.value) {
            document.querySelectorAll('#choose-background input[data-value-24x36]').forEach((input) => {
                input.dataset.imagesourceStandard = input.dataset['imagesource-24x36'].replace('.webp', ' no text.webp');

                if ( input.checked) {
                    document.getElementById('bpic').src = input.dataset.imagesourceStandard;
                }
            });
            document.getElementById('customtext').closest('.input-group').classList.add('d-none');
        } else {
            document.querySelectorAll('#choose-background input[data-value-24x36]').forEach((input) => {
                input.dataset.imagesourceStandard = input.dataset['imagesource-24x36'];

                if ( input.checked) {
                    document.getElementById('bpic').src = input.dataset.imagesourceStandard;
                }
            });
            document.getElementById('customtext').closest('.input-group').classList.remove('d-none');
        }
    };
    document.querySelectorAll('input[name="portraitonly"]').forEach(input => {
        input.addEventListener('change', updatePortraitOnly);
    });

    // Add event listeners to all radio buttons with name 'size'
    const sizeRadios = document.querySelectorAll('input[name="size"]');
    sizeRadios.forEach(radio => {
        radio.addEventListener('change', handleAccordionChange);
        radio.addEventListener('change', updateSizeOptions);
    });

    // Add event listeners to all radio buttons with name 'style'
    const styleRadios = document.querySelectorAll('input[name="style"]');
    styleRadios.forEach(radio => {
        radio.addEventListener('change', handleAccordionChange);
        radio.addEventListener('change', (element) => {
            const input = document.querySelector('input[name="style"]:checked');
            if (!input) {
                return;
            }
            switch (input.value) {
                case 'standard':
                    updateSizeOptions();
                    break;
            }
        });
    });

    // Add event listeners to all radio buttons with name 'style'
    const frameRadios = document.querySelectorAll('input[name="products[0]"]');
    frameRadios.forEach(radio => {
        radio.addEventListener('change', handleAccordionChange);
    });

    let pyoMinDate = new Date();
    pyoMinDate.setDate((new Date()).getDate() + 1);

    let fedexMinDate = new Date();
    fedexMinDate.setDate((new Date()).getDate() + 1);

    let shipMinDate = new Date();
    shipMinDate.setDate((new Date()).getDate() + 2);


    const datepicker = flatpickr("#timeneededpicker", {
        allowInput: false,
        altInput: false,
        altFormat: "F j, Y h:i K",
        dateFormat: "F j, Y h:i K",
        enableTime: true,
        minDate: new Date().fp_incr(1), // 365 days from now
        maxDate: new Date().fp_incr(365) // 365 days from now
    });

    function updateDeliveryInfo()
    {
        const timerContainer = document.getElementById("delivery-timer");
        const countdownElement = document.getElementById("countdown");
        const deliveryDateElement = document.getElementById("delivery-date");
        const deliveryDateRangeElement = document.getElementById("delivery-date-range");
        const pyoDeliveryDateElement = document.getElementById("pyo-delivery-date");

        // Use Intl to get local time in Austin, TX (Central Time)
        const now = new Date();

        // Helper: Format date as Central Time
        function getCentralTime(date)
        {
            return new Date(date.toLocaleString("en-US", { timeZone: "America/Chicago" }));
        }

        const cstTime = getCentralTime(now);

        const cutoffHour = 13; // 1 PM local time in Austin, TX

        // Helper: Check if a date is a weekend
        function isWeekend(date)
        {
            const day = date.getDay();
            return day === 0 || day === 6; // Sunday = 0, Saturday = 6
        }

        // Modified getNextBusinessDay that skips weekends and federal holidays
        function getNextBusinessDay(start)
        {
            let result = new Date(start);
            do {
                result.setDate(result.getDate() + 1);
            } while (isWeekend(result) || fedHolidays.isAHoliday(result));

            return result;
        }

        // Set target time to 1 PM local time in Austin
        let targetTime = getCentralTime(now)
        targetTime.setHours(cutoffHour, 0, 0, 0);

        const timeFormatter = new Intl.DateTimeFormat(undefined, {
            hour: 'numeric',
            minute: 'numeric'
        });

        if (cstTime > targetTime) {
            if (cstTime.getDay() === 5 || cstTime.getDay() === 6 ) {
                pyoMinDate = fromZonedTime(new Date(
                    targetTime.getFullYear(),
                    targetTime.getMonth(),
                    targetTime.getDate()  + ((7 - cstTime.getDay()) % 7),
                    6, // time to 5:00 AM MST
                    0,
                    0,
                    0
                ), 'America/Chicago');
                pyoDeliveryDateElement.innerText = "Sunday by "
            } else if (isWeekend(cstTime)) {
                pyoMinDate = fromZonedTime(new Date(
                    targetTime.getFullYear(),
                    targetTime.getMonth(),
                    targetTime.getDate() + 1,
                    11,
                    0,
                    0,
                    0
                ), 'America/Chicago');
                pyoDeliveryDateElement.innerText = "tomorrow by ";
            } else {
                pyoMinDate = fromZonedTime(new Date(
                    targetTime.getFullYear(),
                    targetTime.getMonth(),
                    targetTime.getDate() + 1,
                    11,
                    0,
                    0,
                    0
                ), 'America/Chicago');
                pyoDeliveryDateElement.innerText = "tomorrow by ";
            }
            pyoDeliveryDateElement.innerText += timeFormatter.format(pyoMinDate);
        } else {
            pyoMinDate = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                now.getHours()+5,
                now.getMinutes(),
                now.getSeconds(),
                0
            );
            pyoDeliveryDateElement.innerText = "in five hours";
        }

        // If past cutoff or weekend, move to the next business day at 3 PM
        if (cstTime > targetTime || isWeekend(cstTime)) {
            targetTime = getNextBusinessDay(targetTime);
            targetTime.setHours(cutoffHour, 0, 0, 0);
        }

        // Calculate delivery date (2 business days from order day)
        const deliveryDate = getNextBusinessDay(getNextBusinessDay(getNextBusinessDay(new Date(targetTime))));
        const deliveryDateFormatter = new Intl.DateTimeFormat(navigator.language, {
            month: 'short',
            day: 'numeric',
        });
        const deliveryDateFormatterDayOnly = new Intl.DateTimeFormat(navigator.language, {
            day: 'numeric',
        });
        deliveryDateElement.textContent = deliveryDateFormatter.format(deliveryDate);

        shipMinDate = deliveryDate;

        const earlyDeliveryDate = getNextBusinessDay(getNextBusinessDay(getNextBusinessDay(getNextBusinessDay(new Date(targetTime)))));

        const lateDeliveryDate = getNextBusinessDay(getNextBusinessDay(getNextBusinessDay(getNextBusinessDay(getNextBusinessDay(getNextBusinessDay(getNextBusinessDay(new Date(targetTime))))))))   ;

        deliveryDateRangeElement.textContent = deliveryDateFormatter.format(earlyDeliveryDate) + ' - ' + deliveryDateFormatterDayOnly.format(lateDeliveryDate);

        // Always show timer
        timerContainer.classList.remove("d-none");

        function updateCountdown()
        {
            const now = new Date();
            const currentTimeCT = getCentralTime(now);
            const timeDifference = targetTime - currentTimeCT;

            if (timeDifference <= 0) {
                clearInterval(countdownInterval);
                // Automatically reset countdown to next cutoff
                setTimeout(() => {
                    updateDeliveryInfo();
                }, 1000);
                return;
            }

            const totalSeconds = Math.floor(timeDifference / 1000);
            const totalMinutes = Math.floor(totalSeconds / 60);
            const totalHours = Math.floor(totalMinutes / 60);
            const days = Math.floor(totalHours / 24);
            const hours = totalHours % 24;
            const minutes = totalMinutes % 60;

            let displayText = "";

            // Helper to format time like "3:45 PM"
            function formatTime(date)
            {
                return date.toLocaleTimeString(navigator.language, {
                    hour: 'numeric',
                    minute: '2-digit'
                });
            }

            const formattedCutoff = formatTime(targetTime);

            if (days === 0) {
                if (hours === 0) {
                    displayText = `within ${minutes} minute${minutes !== 1 ? "s" : ""}`;
                } else {
                    displayText = `within ${hours} hour${hours !== 1 ? "s" : ""} and ${minutes} minute${minutes !== 1 ? "s" : ""}`;
                }
            } else if (days === 1) {
                displayText = `by tomorrow before ${formattedCutoff}`;
            } else if (days < 3) {
                const dayOfWeek = targetTime.toLocaleDateString("en-US", { weekday: "long" });
                displayText = `by ${dayOfWeek} before ${formattedCutoff}`;
            } else {
                const dayOfWeek = targetTime.toLocaleDateString("en-US", { weekday: "long" });
                displayText = `by next ${dayOfWeek} before ${formattedCutoff}`;
            }

            countdownElement.textContent = displayText;
        }

        updateCountdown(); // Initial call
        const countdownInterval = setInterval(updateCountdown, 1000);
    }

    updateDeliveryInfo();

    const updateDeliveryOptions = () => {
        const selected = document.querySelector('input[name="delivery"]:checked')
        if ( ! selected) {
            return;
        }

        switch (selected.value) {
            case 'pyo':
                datepicker.set('minDate', pyoMinDate)
                break;
            case 'pdp':
            case 'pd':
                datepicker.set('minDate', fedexMinDate)
                break;
            default:
                datepicker.set('minDate', shipMinDate)
        }

        if ( 'pyo' === selected.value || 'pdp' === selected.value || 'pd' === selected.value ) {
            document.querySelectorAll('#choose-size-item-fedex-pickup,#choose-size-item-fedex-delivery,#choose-style-item-fedex,#choose-size-item,.choose-frame-item,#choose-size-item-pyo').forEach(itemVisibilityHide);
            if ( 'pdp' === selected.value ) {
                document.querySelectorAll('#choose-size-item-fedex-pickup,#choose-style-item-fedex').forEach(itemVisibilityShow);
            } else if ( 'pd' === selected.value) {
                document.querySelectorAll('#choose-size-item-fedex-delivery,#choose-style-item-fedex').forEach(itemVisibilityShow);
            } else {
                document.querySelectorAll('#choose-size-item-pyo').forEach(itemVisibilityShow);
            }
        } else {
            document.querySelectorAll('#choose-size-item,#choose-style-item').forEach(item => {
                item.classList.remove('d-none');
                item.querySelectorAll('input[data-required]').forEach(input => {
                    input.setAttribute('required', true);
                });
            });
            updateSizeOptions();

            document.querySelectorAll('#choose-size-item-fedex-pickup,#choose-size-item-fedex-delivery,#choose-style-item-fedex,#choose-size-item-pyo').forEach(itemVisibilityHide);
        }
    }

    document.querySelectorAll('input[name="delivery"]').forEach(radio => {
        radio.addEventListener('change', updateDeliveryOptions)
    });
    updateDeliveryOptions();

    // Initialize with the first checked radio button, if any
    const checkedRadios = document.querySelectorAll('input[type="radio"].btn-check:checked');
    checkedRadios.forEach(radio => {
        const headerTextElement = radio.closest('.accordion-item').querySelector('.accordion-button .js-chosen');
        headerTextElement.innerText = radio.getAttribute('data-name');
    });

    document.querySelectorAll('#companylogo').forEach(checkbox => {
        const logoCollapse = new bootstrap.Collapse('#logoform', {
            toggle: false
        })
        checkbox.addEventListener('change', (element) => {
            if ( checkbox.checked ) {
                logoCollapse.show();
            } else {
                logoCollapse.hide();
            }
        });
    });

    // Initialize the total price
    updateTotalPrice();
    // Flatpickr initialization

    // Add event listener to the "Show All Backgrounds" button
    const showAllBackgroundsButton = document.querySelector('#showallbackgrounds');
    if (showAllBackgroundsButton) {
        showAllBackgroundsButton.addEventListener('click', function (e) {
            e.preventDefault();
            const parentElement = this.parentElement.nextElementSibling;
            // Check if the parent element has the 'expanded' class
            if (parentElement.classList.contains('expanded')) {
                // If it does, remove the 'expanded' class and set max-height back to 262px
                parentElement.classList.remove('expanded');
                parentElement.style.maxHeight = '362px';
                this.innerText = 'Show All Backgrounds';
                document.querySelector('#accordionOptions').scrollIntoView()
            } else {
                // If it doesn't, add the 'expanded' class and set max-height to none
                parentElement.classList.add('expanded');
                parentElement.style.maxHeight = '6500px';
                this.innerText = 'Hide Additional Backgrounds';
            }
        });
    }

    'use strict'

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.needs-validation')

    // Loop over them and prevent submission
    Array.from(forms).forEach(form => {
        form.addEventListener('submit', event => {
            if ( datepicker.selectedDates.length <= 0 ) {
                datepicker.open()
                event.preventDefault()
                event.stopPropagation()
                datepicker.input.classList.remove('is-valid')
                datepicker.input.classList.add('is-invalid')
            } else {
                datepicker.close()
                datepicker.input.classList.remove('is-invalid')
                datepicker.input.classList.add('is-valid')
            }

            if (!form.checkValidity()) {
                if (event.submitter.id === 'resetBtn') {
                    // We're only resetting.
                    return;
                }
                event.preventDefault()
                event.stopPropagation()
            }

            form.classList.add('was-validated')

            // Find the first invalid element
            const invalidElements = form.querySelectorAll('.was-validated :invalid ~ .invalid-feedback,.btn-check:invalid, .form-control:invalid, .is-invalid');
            let firstInvalidElement = null;

            for (let i = 0; i < invalidElements.length; i++) {
                if (invalidElements[i].offsetParent !== null) {
                    firstInvalidElement = invalidElements[i];
                    break;
                }
            }

            // If an invalid element is found, scroll to it
            if (firstInvalidElement) {
                window.scrollTo({
                    top: firstInvalidElement.getBoundingClientRect().top + window.scrollY - 100,
                    behavior: 'smooth'
                });

                // Focus the invalid element for better UX
                firstInvalidElement.focus();
            }

        }, false)
    });


    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
        //, {trigger:'click'}
    document.getElementById('togglezoom').addEventListener('click', event => {
        event.stopPropagation();
        event.preventDefault();

        document.querySelectorAll('[data-style-zoom]').forEach((elem) => {
            elem.dataset.styleOrig = elem.style.cssText;
            elem.style = elem.dataset.styleZoom;
        });
        const resetStyles = () => {
            document.querySelectorAll('[data-style-zoom]').forEach((elem) => {
                elem.style = elem.dataset.styleOrig;
            });
        };

        const escHandler = event => {
            if (event.key === 'Escape') {
                resetStyles();
                document.removeEventListener('click', clickHandler);
                document.removeEventListener('keydown', escHandler);
            }
        };

        const clickHandler = () => {
            event.stopPropagation();
            event.preventDefault();
            resetStyles();
            document.removeEventListener('keydown', escHandler);
            document.removeEventListener('click', clickHandler);
        };

        document.addEventListener('click', clickHandler);
        document.addEventListener('keydown', escHandler);

    });

    document.querySelectorAll('#choose-frame-item input[name="products[0]"]').forEach(input => {
        input.addEventListener('change', (event) => {
            const input = document.querySelector('input[name="products[0]"]:checked');
            if (!input) {
                return;
            }
            document.getElementById('framed').checked = true;
        })
    });

    document.querySelectorAll('#choose-frame-item input[name="style"]').forEach(input => {
        input.addEventListener('change', (event) => {
            const input = document.querySelector('input[name="style"]:checked');
            if (!input) {
                return;
            }
            if (input.id !== 'framed') {
                document.querySelectorAll('#choose-frame-item input[name="products[0]"]').forEach(input => {
                    input.required = false;
                    input.checked = false;
                });
            } else {
                document.querySelectorAll('#choose-frame-item input[name="products[0]"]').forEach(input => {
                    input.required = true;
                });
            }
        })
    });


});